import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../../config/assetApiConfig';


// Create Asset Receipt
export const createReceipt = createAsyncThunk(
  'assetReceipt/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.post('/asset-receipt', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create asset receipt');
    }
  }
);

// Fetch All Asset Receipts
export const fetchReceipts = createAsyncThunk(
  'assetReceipt/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get('/asset-receipt');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset receipts');
    }
  }
);

// Fetch Asset Receipt by ID
export const fetchReceiptById = createAsyncThunk(
  'assetReceipt/fetchById',
  async (receiptId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get(`/asset-receipt/${receiptId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset receipt');
    }
  }
);

// Update Asset Receipt
export const updateReceipt = createAsyncThunk(
  'assetReceipt/update',
  async ({ receiptId, ...data }: any & { receiptId: number }, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.put(`/asset-receipt/${receiptId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update asset receipt');
    }
  }
);

// Delete Asset Receipt
export const deleteReceipt = createAsyncThunk(
  'assetReceipt/delete',
  async (receiptId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.delete(`/asset-receipt/${receiptId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete asset receipt');
    }
  }
);
